module.exports = __webpack_public_path__ + "assets/img/oval.d6d66d7a.svg";